var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMinespil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:1;}.b{fill:none;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-11.92 -12.92)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 18,
    transform: "translate(11.92 12.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.4.1l-1.92,1.177L49.557.1A.7.7,0,0,0,48.84.1L46.909,1.231,44.978.1a.7.7,0,0,0-.705,0L42.342,1.231,40.41.1a.7.7,0,0,0-1.049.6V17.142a.7.7,0,0,0,1.061.594l1.92-1.177,1.92,1.177a.7.7,0,0,0,.717.007l1.931-1.133,1.931,1.133a.7.7,0,0,0,.705,0l1.931-1.133,1.931,1.133a.7.7,0,0,0,1.049-.6V.7A.7.7,0,0,0,53.4.1ZM44.865,6.179a.7.7,0,0,1-.7.7H42.8a.7.7,0,1,1,0-1.394h1.37A.7.7,0,0,1,44.865,6.179Zm6.852,0a.7.7,0,0,1-.7.7H46.909a.7.7,0,1,1,0-1.394H51.02A.7.7,0,0,1,51.717,6.179ZM44.865,8.92a.7.7,0,0,1-.7.7H42.8a.7.7,0,1,1,0-1.394h1.37A.7.7,0,0,1,44.865,8.92Zm6.852,0a.7.7,0,0,1-.7.7H46.909a.7.7,0,1,1,0-1.394H51.02A.7.7,0,0,1,51.717,8.92Zm-6.852,2.741a.7.7,0,0,1-.7.7H42.8a.7.7,0,1,1,0-1.394h1.37A.7.7,0,0,1,44.865,11.661Zm6.852,0a.7.7,0,0,1-.7.7H46.909a.7.7,0,1,1,0-1.394H51.02A.7.7,0,0,1,51.717,11.661Z",
    transform: "translate(-25.973 13)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMinespil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/minespil.da446e13.svg";
export { ForwardRef as ReactComponent };